// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ol .items-list-item[data-v-5a970f68]{max-width:inherit}", "",{"version":3,"sources":["webpack://./src/main/webapp/WEB-INF/views/common/components/ob1/ListIcon.vue"],"names":[],"mappings":"AAGI,qCACI,iBAAA","sourcesContent":["\n\nol {\n    .items-list-item {\n        max-width: inherit;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
